/**
 * The names SharePoint refuses for a file or folder — the browser-side mirror of
 * backend/domain/sharepoint-browse.ts#isSafeItemName, so the export dialog can disable Export with
 * an inline reason instead of a round trip. The backend still checks (and has the last word).
 */
const UNSAFE_NAME_CHARS = /["*:<>?/\\|]/
const MAX_NAME_LENGTH = 255

export function isSafeItemName(name: string): boolean {
  if (name.length === 0 || name.length > MAX_NAME_LENGTH) return false
  if (name.trim() !== name) return false // SharePoint silently trims; the file would not be named as typed
  if (name === '.' || name === '..') return false
  if (UNSAFE_NAME_CHARS.test(name)) return false
  if (/[. ]$/.test(name)) return false // a trailing dot/space is also refused
  return true
}
